import { render, staticRenderFns } from "./td-quarternary.vue?vue&type=template&id=2bd2fec6&scoped=true&"
import script from "./td-quarternary.vue?vue&type=script&lang=js&"
export * from "./td-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2fec6",
  null
  
)

export default component.exports